import React, { useEffect } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import ButtonComponent from "../../../components/ButtonComponent";
import { COLORS } from "../../../lib/colors";
import Divider from "@mui/material/Divider";
import * as HTTPServices from "../../../api/HTTPServices";
import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import classes from "./index.module.scss";
import { ReactComponent as UnitedKingdom } from "../../../assets/images/flags/united-kingdom.svg";
import { ReactComponent as Spain } from "../../../assets/images/flags/spain.svg";
import { ReactComponent as Turkey } from "../../../assets/images/flags/turkey.svg";
import { ReactComponent as Iran } from "../../../assets/images/flags/iran.svg";

function Index() {
  const { t, i18n } = useTranslation();
  const [value, setValue] = React.useState(0);
  const [state, setState] = React.useState({
    onlyMyPatient: false,
    limitTodayVisit: false,
    videoCallVisit: false,
    phoneCallVisit: false,
    textChatVisit: false,
    newVisitEmailAlert_Dr: false,
    newVisitEmailAlert_Se: false,
    newVisitSmsAlert_Dr: false,
    newVisitSmsAlert_Se: false,
    waitingListEmailAlert_Dr: false,
    waitingListEmailAlert_Se: false,
    waitingListSmsAlert_Dr: false,
    waitingListSmsAlert_Se: false,
    canselVisitEmailAlert_Dr: false,
    canselVisitEmailAlert_Se: false,
    canselVisitSmsAlert_Dr: false,
    canselVisitSmsAlert_Se: false,
    persianLang: true,
    turkishLang: false,
    englishLang: false,
    arabicLang: false,
    spanishLang: false,
    localTurkish: false,
    localKurdish: false,
    localLori: false,
    localGilaki: false,
  });

  useEffect(() => {
    const RequestService = HTTPServices.getMethod(
      "get_doctor_setting",
      "",
      "true"
    );
    RequestService.then(function (response) {
      if (response) {
        setState(response);
      }
    });
  }, []);

  const handleChangeTab = (event, newValue) => {
    setValue(newValue);
  };

  const changeLanguage = (lng) => {
    let previusLanguage = localStorage.getItem("language");
    if (lng === "fa" && previusLanguage !== "fa") {
      i18n.changeLanguage(lng);
      localStorage.setItem("language", lng);
      window.location.reload();
    } else if (previusLanguage === "fa" && lng !== "fa") {
      i18n.changeLanguage(lng);
      localStorage.setItem("language", lng);
      window.location.reload();
    } else {
      i18n.changeLanguage(lng);
      localStorage.setItem("language", lng);
    }
  };

  let formData = new FormData();
  const handleChange = (event) => {
    // let selectedSetting;
    // selectedSetting = { [event.target.name]: event.target.checked };
    formData.append(`${[event.target.name]}`, event.target.checked);
    setState({ ...state, [event.target.name]: event.target.checked });
    // let obj = state;
    // Object.entries(obj).map(([key, value]) => formData.append([key], value));

    const RequestService = HTTPServices.postMethod(
      "doctor_setting",
      formData,
      "true",
      "post",
      "true"
    );
    RequestService.then(function (response) {
      if (response) {
        console.log("RESPONSE", response);
      } else {
      }
    });
  };

  function a11yProps(index) {
    return {
      id: `scrollable-prevent-tab-${index}`,
      "aria-controls": `scrollable-prevent-tabpanel-${index}`,
    };
  }

  function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`scrollable-prevent-tabpanel-${index}`}
        aria-labelledby={`scrollable-prevent-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box p={3}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }

  return (
    <div>
      <h3 className={classes.title}>
        {t("pages.protectedPages.doctorSetting.title")}
      </h3>
      <hr></hr>
      <Tabs
        value={value}
        // indicatorColor="yellow"
        textColor="primary"
        onChange={handleChangeTab}
        style={{
          borderColor: "#e2dfdf",
        }}
        centered
        TabIndicatorProps={{ style: { background: "#f7b500" } }}
      >
        <Tab
          label={t("pages.protectedPages.doctorSetting.visitSettings")}
          style={value === 0 ? tabStyles.activeTabStyle : tabStyles.tab}
          fullWidth
          {...a11yProps(0)}
        />
        <Tab
          label={t("pages.protectedPages.doctorSetting.smsEmailSettings")}
          style={value === 1 ? tabStyles.activeTabStyle : tabStyles.tab}
          fullWidth
          {...a11yProps(1)}
        />
        <Tab
          label={t("pages.protectedPages.doctorSetting.acceptableLanguages")}
          style={value === 2 ? tabStyles.activeTabStyle : tabStyles.tab}
          fullWidth
          {...a11yProps(2)}
        />
        <Tab
          label={t("pages.protectedPages.doctorSetting.siteSettings")}
          style={value === 3 ? tabStyles.activeTabStyle : tabStyles.tab}
          fullWidth
          {...a11yProps(3)}
        />
      </Tabs>
      <TabPanel style={{ padding: 15 }} value={value} index={0}>
        <FormGroup>
          <FormControlLabel
            control={
              <Switch
                checked={state.onlyMyPatient}
                onChange={handleChange}
                name="onlyMyPatient"
              />
            }
            label={t("pages.protectedPages.doctorSetting.prevPatient")}
          />
          <FormControlLabel
            control={
              <Switch
                checked={state.limitTodayVisit}
                onChange={handleChange}
                name="limitTodayVisit"
              />
            }
            label={t("pages.protectedPages.doctorSetting.currentDay")}
          />
          <FormControlLabel
            control={
              <Switch
                checked={state.videoCallVisit}
                onChange={handleChange}
                name="videoCallVisit"
              />
            }
            label={t("pages.protectedPages.doctorSetting.videoVisit")}
          />
          <FormControlLabel
            control={
              <Switch
                checked={state.phoneCallVisit}
                onChange={handleChange}
                name="phoneCallVisit"
              />
            }
            label={t(
              "pages.protectedPages.doctorSetting.telephonAendAudioVisitsntDay"
            )}
          />

          <FormControlLabel
            control={
              <Switch
                checked={state.textChatVisit}
                onChange={handleChange}
                name="textChatVisit"
              />
            }
            label={t("pages.protectedPages.doctorSetting.textVisit")}
          />
        </FormGroup>
      </TabPanel>
      <TabPanel style={{ padding: 15 }} value={value} index={1}>
        <Grid container>
          <Grid>
            <div style={{ textAlign: "center" }}>
              <h5>{t("pages.protectedPages.doctorSetting.settingsForDr")}</h5>
            </div>
            <FormGroup>
              <FormControlLabel
                control={
                  <Switch
                    checked={state.newVisitEmailAlert_Dr}
                    onChange={handleChange}
                    name="newVisitEmailAlert_Dr"
                  />
                }
                label={t("pages.protectedPages.doctorSetting.emailOnNewVisit")}
              />
              <FormControlLabel
                control={
                  <Switch
                    checked={state.newVisitSmsAlert_Dr}
                    onChange={handleChange}
                    name="newVisitSmsAlert_Dr"
                  />
                }
                label={t("pages.protectedPages.doctorSetting.smsOnNewVisit")}
              />
              <FormControlLabel
                control={
                  <Switch
                    checked={state.waitingListEmailAlert_Dr}
                    onChange={handleChange}
                    name="waitingListEmailAlert_Dr"
                  />
                }
                label={t("pages.protectedPages.doctorSetting.waitingListEmail")}
              />
              <FormControlLabel
                control={
                  <Switch
                    checked={state.waitingListSmsAlert_Dr}
                    onChange={handleChange}
                    name="waitingListSmsAlert_Dr"
                  />
                }
                label={t("pages.protectedPages.doctorSetting.waitingListSms")}
              />
              <FormControlLabel
                control={
                  <Switch
                    checked={state.canselVisitEmailAlert_Dr}
                    onChange={handleChange}
                    name="canselVisitEmailAlert_Dr"
                  />
                }
                label={t(
                  "pages.protectedPages.doctorSetting.canselVisitEmailAlert"
                )}
              />
              <FormControlLabel
                control={
                  <Switch
                    checked={state.canselVisitSmsAlert_Dr}
                    onChange={handleChange}
                    name="canselVisitSmsAlert_Dr"
                  />
                }
                label={t(
                  "pages.protectedPages.doctorSetting.canselVisitSmsAlert"
                )}
              />
            </FormGroup>
          </Grid>
          <Grid>
            <div style={{ textAlign: "center" }}>
              <h5>{t("pages.protectedPages.doctorSetting.settingsForSec")}</h5>
            </div>
            <FormGroup>
              <FormControlLabel
                control={
                  <Switch
                    checked={state.newVisitEmailAlert_Se}
                    onChange={handleChange}
                    name="newVisitEmailAlert_Se"
                  />
                }
                label={t("pages.protectedPages.doctorSetting.emailOnNewVisit")}
              />
              <FormControlLabel
                control={
                  <Switch
                    checked={state.newVisitSmsAlert_Se}
                    onChange={handleChange}
                    name="newVisitSmsAlert_Se"
                  />
                }
                label={t("pages.protectedPages.doctorSetting.smsOnNewVisit")}
              />
              <FormControlLabel
                control={
                  <Switch
                    checked={state.waitingListEmailAlert_Se}
                    onChange={handleChange}
                    name="waitingListEmailAlert_Se"
                  />
                }
                label={t("pages.protectedPages.doctorSetting.waitingListEmail")}
              />
              <FormControlLabel
                control={
                  <Switch
                    checked={state.waitingListSmsAlert_Se}
                    onChange={handleChange}
                    name="waitingListSmsAlert_Se"
                  />
                }
                label={t("pages.protectedPages.doctorSetting.waitingListSms")}
              />
              <FormControlLabel
                control={
                  <Switch
                    checked={state.canselVisitEmailAlert_Se}
                    onChange={handleChange}
                    name="canselVisitEmailAlert_Se"
                  />
                }
                label={t(
                  "pages.protectedPages.doctorSetting.canselVisitEmailAlert"
                )}
              />
              <FormControlLabel
                control={
                  <Switch
                    checked={state.canselVisitSmsAlert_Se}
                    onChange={handleChange}
                    name="canselVisitSmsAlert_Se"
                  />
                }
                label={t(
                  "pages.protectedPages.doctorSetting.canselVisitSmsAlert"
                )}
              />
            </FormGroup>
          </Grid>
        </Grid>
      </TabPanel>
      <TabPanel style={{ padding: 15 }} value={value} index={2}>
        <div style={{ textAlign: "center" }}>
          <h4>
            {t(
              "pages.protectedPages.doctorSetting.acceptedInternationalLanguages"
            )}
          </h4>
        </div>
        <Divider />
        <FormGroup>
          <FormControlLabel
            control={
              <Switch
                checked={state.persianLang}
                onChange={handleChange}
                name="persianLang"
              />
            }
            label={t("pages.protectedPages.doctorSetting.fa")}
          />
          <FormControlLabel
            control={
              <Switch
                checked={state.turkishLang}
                onChange={handleChange}
                name="turkishLang"
              />
            }
            label={t("pages.protectedPages.doctorSetting.tr")}
          />
          <FormControlLabel
            control={
              <Switch
                checked={state.englishLang}
                onChange={handleChange}
                name="englishLang"
              />
            }
            label={t("pages.protectedPages.doctorSetting.en")}
          />
          <FormControlLabel
            control={
              <Switch
                checked={state.arabicLang}
                onChange={handleChange}
                name="arabicLang"
              />
            }
            label={t("pages.protectedPages.doctorSetting.ar")}
          />
          <FormControlLabel
            control={
              <Switch
                checked={state.spanishLang}
                onChange={handleChange}
                name="spanishLang"
              />
            }
            label={t("pages.protectedPages.doctorSetting.es")}
          />
        </FormGroup>
      </TabPanel>

      <TabPanel style={{ padding: 15 }} value={value} index={3}>
        <div style={{ display: "flex", justifyContent: "space-around" }}>
          <ButtonComponent
            className={classes.languageBtn}
            backgroundColor={COLORS.primary}
            // width={140}
            onClick={() => {
              changeLanguage("en");
              localStorage.setItem("language", "en");
            }}
            icon={<UnitedKingdom width={30} height={30} />}
          >
            <span className={classes.langName}>
              {t("pages.protectedPages.doctorSetting.en")}
            </span>
          </ButtonComponent>
          <ButtonComponent
            className={classes.languageBtn}
            backgroundColor={COLORS.primary}
            // width={140}
            onClick={() => changeLanguage("es")}
            icon={<Spain width={30} height={30} />}
          >
            <span className={classes.langName}>
              {t("pages.protectedPages.doctorSetting.es")}
            </span>
          </ButtonComponent>
          <ButtonComponent
            className={classes.languageBtn}
            backgroundColor={COLORS.primary}
            // width={140}
            onClick={() => changeLanguage("tr")}
            icon={<Turkey width={30} height={30} />}
          >
            <span className={classes.langName}>
              {t("pages.protectedPages.doctorSetting.tr")}
            </span>
          </ButtonComponent>
          <ButtonComponent
            className={classes.languageBtn}
            backgroundColor={COLORS.primary}
            // width={140}
            onClick={() => {
              changeLanguage("fa");
              localStorage.setItem("language", "fa");
            }}
            icon={<Iran width={30} height={30} />}
          >
            <span className={classes.langName}>
              {t("pages.protectedPages.doctorSetting.fa")}
            </span>
          </ButtonComponent>
        </div>
      </TabPanel>
    </div>
  );
}

export default Index;

const tabStyles = {
  tab: {
    fontSize: 14,
    fontFamily: "iranyekan",
    paddingRight: 10,
    paddingLeft: 10,
  },
  activeTabStyle: {
    fontSize: 14,
    fontFamily: "iranyekan",
    backgroundColor: "#fef8e6",
    color: "#f7b500",
    paddingRight: 10,
    paddingLeft: 10,
  },
};
